<script setup lang="ts">
import amex from '@/assets/card-flags/amex.png'
import aura from '@/assets/card-flags/aura.png'
import avista from '@/assets/card-flags/avista.png'
import banese from '@/assets/card-flags/banese.png'
import cabal from '@/assets/card-flags/cabal.png'
import cardban from '@/assets/card-flags/cardban.png'
import diners from '@/assets/card-flags/dinners.png'
import elo from '@/assets/card-flags/elo.png'
import fort from '@/assets/card-flags/fort.png'
import grand from '@/assets/card-flags/grand.png'
import hipercard from '@/assets/card-flags/hipercard.png'
import mais from '@/assets/card-flags/mais.png'
import mastercard from '@/assets/card-flags/mastercard.png'
import personal from '@/assets/card-flags/personal.png'
import pleno from '@/assets/card-flags/pleno.png'
import sorocred from '@/assets/card-flags/soro.png'
import up from '@/assets/card-flags/up.png'
import vale from '@/assets/card-flags/vale.png'
import visa from '@/assets/card-flags/visa.png'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { cn } from '@/lib/utils'
import { HTMLAttributes } from 'vue'

const cardFlags = [
    {
        name: 'elo',
        src: elo,
    },
    {
        name: 'mastercard',
        src: mastercard,
    },
    {
        name: 'visa',
        src: visa,
    },
    {
        name: 'amex',
        src: amex,
    },
    {
        name: 'diners',
        src: diners,
    },
    {
        name: 'aura',
        src: aura,
    },
    {
        name: 'avista',
        src: avista,
    },
    {
        name: 'banese',
        src: banese,
    },
    {
        name: 'cabal',
        src: cabal,
    },
    {
        name: 'cardban',
        src: cardban,
    },
    {
        name: 'fort',
        src: fort,
    },
    {
        name: 'hipercard',
        src: hipercard,
    },
    {
        name: 'grand',
        src: grand,
    },
    {
        name: 'mais',
        src: mais,
    },
    {
        name: 'personal',
        src: personal,
    },
    {
        name: 'sorocred',
        src: sorocred,
    },
    {
        name: 'pleno',
        src: pleno,
    },
    {
        name: 'up',
        src: up,
    },
    {
        name: 'vale',
        src: vale,
    },
]

const props = defineProps<{
    title: string
    class?: HTMLAttributes['class']
}>()
</script>

<template>
    <div :class="cn('font-inter overflow-hidden rounded-[10px] border border-slate-300', props.class)">
        <header class="font-inter flex flex-col bg-slate-50 p-4 font-medium md:p-6">
            {{ title }}

            <Dialog>
                <DialogTrigger class="mt-1 w-fit cursor-pointer text-left text-xs text-slate-500 underline">
                    {{ $t('Accepted payment methods') }}
                </DialogTrigger>
                <DialogContent>
                    <DialogHeader class="">
                        <DialogTitle>{{ $t('Accepted payment methods') }}</DialogTitle>
                    </DialogHeader>
                    <div class="flex flex-wrap items-center justify-center gap-2">
                        <div v-for="flag in cardFlags" :key="flag.name" class="h-[52] w-[72px] basis-1/6 border p-3">
                            <img :src="flag.src" :alt="flag.name" class="h-[42px] w-full object-contain" />
                            <span class="sr-only">{{ flag.name }}</span>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </header>
        <div class="p-4 md:p-6">
            <slot />
        </div>
    </div>
</template>
